module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-6.50edadb9.mp3";